import { cx } from "../../lib/cx.js";
import { useOptionalBrand } from "../ThemeRoot/BrandContext.js";
/* empty css              */
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/BrandMark/BrandMark.tsx
function logoSources(logo) {
	if (typeof logo === "string") return [{
		png: logo,
		variant: "single"
	}];
	return [{
		png: logo.light,
		webp: logo.webp?.light,
		variant: "light"
	}, {
		png: logo.dark,
		webp: logo.webp?.dark,
		variant: "dark"
	}];
}
/**
* The brand mark or wordmark. A supplied logo is used as artwork (never recreated
* with fonts), with clear space around it; the variant for light or dark surfaces is
* chosen by the theme. Otherwise the first letter of the name shows on the primary
* colour.
*/
function BrandMark({ name: nameProp, logo: logoProp, size = "lg", showName = false, letterMark: letterMarkProp, className, style, ...rest }) {
	const brand = useOptionalBrand();
	const name = nameProp ?? brand?.brandName;
	if (name === void 0) throw new Error("BrandMark needs a name, or a <ThemeRoot> above it");
	const logo = (logoProp === void 0 ? brand?.logo : logoProp) ?? void 0;
	const letterMark = letterMarkProp ?? brand?.letterMark ?? true;
	const [failedLogo, setFailedLogo] = useState();
	const failed = logo !== void 0 && failedLogo === logo;
	const logoMeta = typeof logo === "object" ? logo : void 0;
	const alt = showName ? "" : logoMeta?.alt ?? name;
	const logoStyle = logoMeta?.height ? {
		"--_logo-height": `${logoMeta.height}px`,
		"--_logo-clear-space": String(logoMeta.clearSpace ?? 0)
	} : void 0;
	let mark;
	if (logo !== void 0 && !failed) mark = /* @__PURE__ */ jsx("span", {
		className: "ds-brandmark__logo",
		style: logoStyle,
		children: logoSources(logo).map(({ png, webp, variant }) => /* @__PURE__ */ jsxs("picture", {
			className: `ds-brandmark__picture--${variant}`,
			children: [webp && /* @__PURE__ */ jsx("source", {
				srcSet: webp,
				type: "image/webp"
			}), /* @__PURE__ */ jsx("img", {
				className: "ds-brandmark__img",
				src: png,
				alt,
				onError: () => setFailedLogo(logo)
			})]
		}, variant))
	});
	else if (letterMark) mark = /* @__PURE__ */ jsx("span", {
		className: "ds-brandmark__letter",
		...showName ? { "aria-hidden": true } : {
			role: "img",
			"aria-label": name
		},
		children: name.trim().charAt(0).toUpperCase()
	});
	else if (!showName) mark = /* @__PURE__ */ jsx("span", {
		className: "ds-brandmark__text",
		children: name
	});
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-brandmark", `ds-brandmark--${size}`, className),
		style,
		...rest,
		children: [mark, showName && /* @__PURE__ */ jsx("span", {
			className: "ds-brandmark__name",
			children: name
		})]
	});
}
//#endregion
export { BrandMark };

//# sourceMappingURL=BrandMark.js.map